import { NewLine } from '@/components/Form/Fields';
import FormField from '@/components/Form/FormField';
import FormPage from '@/components/Form/FormPage';
import type { FormValues, PageBlok } from '@/components/Form/types';
import type { GenericBlok } from '@/components/customFields/types';
import type { FormStoryblok } from '@/types/component-types-sb';

export const renderFormFields = (
  blok: FormStoryblok,
  values: FormValues,
  activeStep: number = 0,
  embedded: boolean | undefined = true
) => {
  return blok.content && blok.content?.length > 0 && blok.content[0]?.component === 'FormPage' ? (
    <FormPage
      pageBlok={blok.content[activeStep] as PageBlok}
      index={activeStep}
      formValues={values}
      embedded={embedded}
      form={blok}
    />
  ) : (
    <>
      {blok.content?.map((pageBlok: GenericBlok, index) => {
        if (pageBlok.component === 'NewLine') {
          return <NewLine key={index} />;
        }
        return <FormField form={blok} key={index} fieldBlok={pageBlok} index={index} formValues={values} />;
      })}
    </>
  );
};
